require('jquery');


$(document).ready(function(){
   $('a[data-toggle="tab"]').click(function(){
       let container = $(this).parents('ul.nav-tabs');
       container.find('a[data-toggle="tab"]').parent().removeClass('active');
       $(this).parent().toggleClass('active');
   })
});


// WEBPACK FOOTER //
// ./resources/js/tabs.js